import { httpClient } from '@/shared/api/http-client';
import { publicClient } from '@/shared/api/public-client';

// Backend is Sanctum Bearer (no /auth prefix, no refresh flow).
// Guest endpoints go through publicClient; authenticated ones through
// httpClient (attaches the Bearer + handles 401).

/** `{ data: user, token }` -> `{ user, token }`. */
function toSession(data) {
  return { user: data.data, token: data.token };
}

export async function login({ email, password, remember = false }, { signal } = {}) {
  const { data } = await publicClient.post('/login', { email, password, remember }, { signal });
  return toSession(data);
}

/** Create an unverified account and mail a 6-digit OTP. Returns `{ message }`. */
export async function register(payload, { signal } = {}) {
  const { data } = await publicClient.post('/register', payload, { signal });
  return data;
}

/** Verify the OTP → activate the account. Returns `{ user, token }`. */
export async function verifyOtp({ email, otp }, { signal } = {}) {
  const { data } = await publicClient.post('/verify-otp', { email, otp }, { signal });
  return toSession(data);
}

/** Request a fresh OTP (throttled, no account enumeration). Returns `{ message }`. */
export async function resendOtp({ email }, { signal } = {}) {
  const { data } = await publicClient.post('/resend-otp', { email }, { signal });
  return data;
}

/** Mail a 6-digit password reset code. Returns `{ message }`. */
export async function requestPasswordReset({ email }, { signal } = {}) {
  const { data } = await publicClient.post('/forgot-password', { email }, { signal });
  return data;
}

/** Exchange the code for a new password. Returns `{ message }`. */
export async function resetPassword({ email, otp, password }, { signal } = {}) {
  const { data } = await publicClient.post(
    '/reset-password',
    { email, otp, password },
    { signal },
  );
  return data;
}

/** Restore the current user from the stored token. */
export async function fetchMe({ signal } = {}) {
  const { data } = await httpClient.get('/me', { signal });
  return data.data;
}

export async function logout() {
  await httpClient.post('/logout');
}
